import { QueryExpressionParserService, SimpleChipExpression, ExpertChipExpression } from "@nrwl/query-emitter";
import { Injectable } from "@angular/core";

@Injectable()
export class DemoQueryExpressionParserService extends QueryExpressionParserService {
  supportedSearchKeywords: string[];

  constructor() {
    super();
  }

  public setSupportedSearchKeywords(keywords: string[]) {
    this.supportedSearchKeywords = keywords;
  }

  public isChipExpressionValid(chipExpression: string): boolean {
    return true;
  }

  public isExpressionValid(expression: string): boolean {
    return true;
  }

  public fitsWithUseCaseConstraints(chips: SimpleChipExpression[]): boolean {
    return true;
  }

  public parseIntoTokens(expression: string): ExpertChipExpression[] {
    return null;
  }

  public parseChipIntoTokens(chipExpression: string): SimpleChipExpression {
    return null;
  }
  public getChipKeywords(): string[] {
    return ['keyword1', 'keyword2'];
  }

  public getChipOperators(): string[] {
    return ['=', '>', '<'];
  }

  public toExpression(chips: SimpleChipExpression[]): string {
    return 'demo expression';
  }

  toBreadcrumbExp(chips: SimpleChipExpression[]): string {
    return 'host 192.168.100.102';
  }

  public toAtaBreadcrumbExp(chips: SimpleChipExpression[]): string {
    return "127.0.0.1 / MSRCP";
  }

  public areChipKeywordValid() {
    return true;
  }
}
